var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "viewBox": "0 0 512 512",
      "xml:space": "preserve",
      "fill": "#000000",
      "width": "200px",
      "height": "200px"
    }
  }, [_c('g', {
    attrs: {
      "id": "SVGRepo_bgCarrier",
      "stroke-width": "0"
    }
  }), _c('g', {
    attrs: {
      "id": "SVGRepo_tracerCarrier",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('g', {
    attrs: {
      "id": "SVGRepo_iconCarrier"
    }
  }, [_c('circle', {
    staticStyle: {
      "fill": "#71e2ef"
    },
    attrs: {
      "cx": "256",
      "cy": "256",
      "r": "256"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#38c6d9"
    },
    attrs: {
      "d": "M261.203,511.934C400.184,509.161,512,395.645,512,256c0-2.725-0.057-5.439-0.141-8.144 L384.546,120.544l-58.89,103.35L150.842,389.07l46.271,46.271l-7.202,5.299L261.203,511.934z"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#ff5419"
    },
    attrs: {
      "x": "189.905",
      "y": "371.881",
      "width": "22.921",
      "height": "68.761"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#273b7a"
    },
    attrs: {
      "d": "M184.18,389.07h185.101c11.7,0,21.183-9.485,21.183-21.183V135.209 c0-11.7-9.485-21.183-21.183-21.183H184.18V389.07z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#121149"
    },
    attrs: {
      "d": "M369.281,114.024h-82.825V389.07h82.825c11.7,0,21.183-9.485,21.183-21.183V135.209 C390.465,123.509,380.98,114.024,369.281,114.024z"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#386895"
    },
    attrs: {
      "x": "150.842",
      "y": "114.019",
      "width": "41.667",
      "height": "275.049"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M331.497,210.803c-4.343,0-8.457,0.969-12.148,2.691c-4.725-12.519-16.812-21.426-30.984-21.426 s-26.259,8.907-30.984,21.426c-3.691-1.724-7.806-2.691-12.148-2.691c-15.881,0-28.755,12.874-28.755,28.755 s12.874,28.755,28.755,28.755c2.484,0,4.889-0.331,7.189-0.922v72.809h71.887V267.39c2.3,0.593,4.705,0.922,7.189,0.922 c15.881,0,28.755-12.874,28.755-28.755S347.377,210.803,331.497,210.803z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#d0d1d3"
    },
    attrs: {
      "d": "M331.497,210.803c-4.343,0-8.457,0.969-12.148,2.691c-4.725-12.519-16.812-21.426-30.984-21.426 c-0.643,0-1.276,0.038-1.908,0.074v148.056h37.852v-72.809c2.3,0.593,4.705,0.922,7.189,0.922c15.881,0,28.755-12.874,28.755-28.755 S347.377,210.803,331.497,210.803z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }